import { UserDispatcherListItem } from "../../../../../common/services/user/dispatcher/list/user-dispatcher-list";
import UserStatus from "../../../../../common/types/user-status";
import phoneNumberService from "../../../../../common/utils/phone-number/phone-number.service";
import DispatcherListingItem from "./types/dispatcher-listing-item";

const createPhoneNumbers = (
  listItem: UserDispatcherListItem,
): DispatcherListingItem["phoneNumbers"] => {
  const phoneNumbers: DispatcherListingItem["phoneNumbers"] = [
    phoneNumberService.getLabel(listItem.phoneNumber),
  ];

  if (listItem.alternativePhoneNumber) {
    phoneNumbers.push(
      phoneNumberService.getLabel(listItem.alternativePhoneNumber),
    );
  }

  return phoneNumbers;
};

const createListingItem = (
  listItem: UserDispatcherListItem,
): DispatcherListingItem => {
  const phoneNumbers = createPhoneNumbers(listItem);

  return {
    uuid: listItem.uuid,
    cargoCompanyName: listItem.cargoCompany.displayName,
    firstName: listItem.firstName,
    lastName: listItem.lastName,
    dispatch: listItem.dispatch.name,
    email: listItem.email,
    username: listItem.username,
    phoneNumbers,
    status: !listItem.removalDate ? UserStatus.ACTIVE : UserStatus.DELETED,
  };
};

const createListingItems = (
  listItems: UserDispatcherListItem[],
): DispatcherListingItem[] => {
  return listItems.map(createListingItem);
};

const dispatcherListingItemFactory = {
  createListingItems,
};

export default dispatcherListingItemFactory;
